import { render, staticRenderFns } from "./messages-list.vue?vue&type=template&id=51dd475e&scoped=true"
import script from "./messages-list.vue?vue&type=script&lang=js"
export * from "./messages-list.vue?vue&type=script&lang=js"
import style0 from "./messages-list.vue?vue&type=style&index=0&id=51dd475e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51dd475e",
  null
  
)

export default component.exports